module.exports = " <v-header></v-header> <div class=container-fluid id=allProducts> <v-banner :show.sync=store.banner.Enabled :banner=store.banner></v-banner> <router-view></router-view> </div> <v-footer></v-footer> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/App.vue
// module id = 637
// module chunks = 0